if (!customElements.get('custom-slider')) {
  customElements.define(
    'custom-slider',

    class TeamSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.delayAutoplay = 3500;
        this.slider = this.querySelector('.carousel');
        this.nextButton = this.querySelector('button[name="next-team"]');
        this.prevButton = this.querySelector('button[name="previous-team"]');
        this.totalSlidesToShow = parseInt(
          this.slider.attributes['total-slides'] ? this.slider.attributes['total-slides'].value : 4
        );
        if (!this.nextButton) return;
        const totalSlider = this.querySelectorAll('li').length;
        this.totalElements = window.innerWidth < 990 ? totalSlider - 1 : totalSlider - (this.totalSlidesToShow-1);
        if (this.totalElements > 1) {
          this.createDots();
          this.slidePercentage = window.innerWidth < 990 ? 50 : (100/this.totalSlidesToShow);
          this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
          this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
          this.addEventListener('mouseenter', this.focusInHandling.bind(this));
          this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
          this.startAutoScroll();
          window.addEventListener('resize', this.updateDimensions.bind(this));
          this.slider.addEventListener('touchstart', this.onTouchStart.bind(this),{passive: true});
          this.slider.addEventListener('touchmove', this.onTouchMove.bind(this),{passive: true});
          this.slider.addEventListener('touchend', this.onTouchEnd.bind(this),{passive: true});
        }
      }
      onTouchStart(event) {
        this.touchStartX = event.touches[0].clientX;
        this.stopAutoScroll();
      }
      
      onTouchMove(event) {
        if (!this.touchStartX) return;
        const touchEndX = event.touches[0].clientX;
        const deltaX = touchEndX - this.touchStartX;
        const threshold = 50;
        if (deltaX > threshold) {
          this.onButtonClick({ currentTarget: { name: 'previous-team' } });
          this.touchStartX = null;
        } else if (deltaX < -threshold) {
          this.onButtonClick({ currentTarget: { name: 'next-team' } });
          this.touchStartX = null;
        }
      }
      onTouchEnd() {
        this.touchStartX = null;
        this.startAutoScroll();
      }
      onButtonClick(event) {

        const isNext = event.currentTarget.name === 'next-team';
        this.currentIndex = isNext
          ? (this.currentIndex + 1) % this.totalElements
          : (this.currentIndex - 1 + this.totalElements) % this.totalElements;
        this.updateSlidePosition();
      }
      focusInHandling() {
        this.nextButton.classList.add('show-actions');
        this.prevButton.classList.add('show-actions');
        this.stopAutoScroll();
      }
      focusOutHandling() {
        this.nextButton.classList.remove('show-actions');
        this.prevButton.classList.remove('show-actions');
        this.startAutoScroll();
      }

      updateSlidePosition() {
        const leftValue = `translateX(-${this.currentIndex * this.slidePercentage}%)`;
        this.slider.style.transform = leftValue;
        this.updateDots();
      }
      startAutoScroll() {
        this.autoScrollInterval = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.totalElements;
          this.updateSlidePosition();
        }, this.delayAutoplay);
      }
      stopAutoScroll() {
        clearInterval(this.autoScrollInterval);
      }
      createDots() {
        const dotsContainer = this.querySelector('.dots-container');
        dotsContainer.innerHTML = '';

        for (let i = 0; i < this.totalElements; i++) {
          const dot = document.createElement('span');
          dot.classList.add('dot');
          dot.dataset.index = i;
          if (i === 0) {
            dot.classList.add('active');
          }
          dotsContainer.appendChild(dot);
          dot.addEventListener('click', () => {
            this.currentIndex = i;
            this.updateSlidePosition();
            this.updateDots();
          });
        }
      }

      updateDots() {
        const dots = this.querySelectorAll('.dot');
        dots.forEach((dot, index) => {
          if (index === this.currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }
      updateDimensions() {
        const totalSlider = this.querySelectorAll('li').length;
        this.totalElements = window.innerWidth < 990 ? totalSlider - 1 : totalSlider - 3;
        this.slidePercentage = window.innerWidth < 990 ? 50 : (100/this.totalSlidesToShow);
        this.createDots();
      }
    }
  );
}
